import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from "./components/Authentication/Login";
import Register from "./components/Authentication/Register";
import WhatsAppPage from "./components/whatsapp api/WhatsAppPage";
import ForgotPassword from "./components/Authentication/ForgotPassword";
import ResetPassword from "./components/Authentication/ResetPassword";
import HomePage from "./components/HomePage";
import WhatsAppMessagesTable from "./components/whatsapp api/WhatsAppMessagesTable";
import AuthWrapper from "./components/AuthWrapper"; // Import the AuthWrapper
import ProfilePage from "./components/whatsapp api/ProfilePage";
import AdminDashboard from "./components/Admin/AdminDashboard";
import ContactUs from "./components/whatsapp api/ContactUs";
import UsersTable from "./components/Admin/UserTable";
import ScheduleMessagePage from "./components/whatsapp api/ScheduleMessagePage";
import SentMessages from "./components/whatsapp api/SentMessages";
import TemplatePage from "./components/whatsapp api/TemplatePage";
import RecurringMessagePage from "./components/whatsapp api/RecurringMessagePage";
import RaiseQuery from "./components/whatsapp api/RaiseQuery";
import QueriesPage from "./components/Admin/QueriesPage";
import ListOfAllGroups from "./components/whatsapp api/Whatsapp Groups/ListOfAllGroups";
import GroupDetails from "./components/whatsapp api/Whatsapp Groups/GroupDetails";
import MainHomepage from "./components/Homepage/MainHomepage";
// import Component from "./components/pricing-page";
import { ThemeProvider } from "./contexts/ThemeContext.jsx";
import LandingPage from "./pages/LandingPage.jsx";
import Auth from "./components/Authentication/Auth";
import Dashboard from "./components/Dashboard/Dashboard.jsx";
import ImpersonationSession from "./components/Authentication/ImpersonationSession.jsx";

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="containerfull">
          <Routes>
            <Route path="/" element={<LandingPage />} />

            {/* Protected routes for regular users */}
            <Route
              path="/whatsappdashboard"
              element={
                <AuthWrapper allowedRoles={[false]}>
                  {" "}
                  {/* Regular users */}
                  <Dashboard />
                </AuthWrapper>
              }
            />
            <Route
              path="/create-new"
              element={
                <AuthWrapper allowedRoles={[false]}>
                  {" "}
                  {/* Regular users */}
                  <WhatsAppPage />
                </AuthWrapper>
              }
            />
            <Route
              path="/whatsapp-message"
              element={
                <AuthWrapper allowedRoles={[false]}>
                  {" "}
                  {/* Regular users */}
                  <WhatsAppMessagesTable />
                </AuthWrapper>
              }
            />
            <Route
              path="/settings"
              element={
                <AuthWrapper allowedRoles={[false]}>
                  {" "}
                  {/* Regular users */}
                  <ProfilePage />
                </AuthWrapper>
              }
            />
            <Route
              path="/contact"
              element={
                <AuthWrapper allowedRoles={[false]}>
                  {" "}
                  {/* Regular users */}
                  <ContactUs />
                </AuthWrapper>
              }
            />

            {/* Protected route for admins */}
            <Route
              path="/admin"
              element={
                <AuthWrapper allowedRoles={[true]}>
                  {" "}
                  {/* Admins only */}
                  <AdminDashboard />
                </AuthWrapper>
              }
            />

            <Route
              path="/sent-message"
              element={
                <AuthWrapper allowedRoles={[false]}>
                  {" "}
                  {/* Admins only */}
                  <SentMessages />
                </AuthWrapper>
              }
            />

            <Route
              path="/schedule"
              element={
                <AuthWrapper allowedRoles={[false]}>
                  {" "}
                  {/* Admins only */}
                  <ScheduleMessagePage />
                </AuthWrapper>
              }
            />

            <Route
              path="/contactus"
              element={
                <AuthWrapper allowedRoles={[false]}>
                  {" "}
                  {/* Admins only */}
                  <ContactUs />
                </AuthWrapper>
              }
            />
            <Route
              path="/template"
              element={
                <AuthWrapper allowedRoles={[false]}>
                  {" "}
                  {/* Admins only */}
                  <TemplatePage />
                </AuthWrapper>
              }
            />
            <Route
              path="/Birthday/schedule"
              element={
                <AuthWrapper allowedRoles={[false]}>
                  {" "}
                  {/* Admins only */}
                  <RecurringMessagePage />
                </AuthWrapper>
              }
            />
            <Route
              path="/raise-a-query"
              element={
                <AuthWrapper allowedRoles={[false]}>
                  {" "}
                  {/* Admins only */}
                  <RaiseQuery />
                </AuthWrapper>
              }
            />
            <Route
              path="/User-queries"
              element={
                <AuthWrapper allowedRoles={[true]}>
                  {" "}
                  {/* Admins only */}
                  <QueriesPage />
                </AuthWrapper>
              }
            />
            <Route
              path="/whatsapp-groups-details"
              element={
                <AuthWrapper allowedRoles={[false]}>
                  <ListOfAllGroups />
                </AuthWrapper>
              }
            />
            <Route
              path="/group/:groupId"
              element={
                <AuthWrapper allowedRoles={[false]}>
                  <GroupDetails />
                </AuthWrapper>
              }
            />

            <Route path="/forget-password" element={<ForgotPassword />} />
            <Route path="/reset-password/:token" element={<ResetPassword />} />
            <Route path="/auth" element={<Auth />} />
            <Route path="/impersonate" element={<ImpersonationSession />} />
          </Routes>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;

//
